// File Metadata:
// Filename: useAuth.js
// Version: 1.00
// Created: 2022-08-25 15:35:54
// Last Modified: 2025-04-01 17:27:27
// Authors: [Your Name]
// Description: A brief summary of what this file does

import { useSelector } from 'react-redux'
import { selectCurrentUser } from '../features/auth/authSlice'

const useAuth = () => {
    const user = useSelector(selectCurrentUser)
    
    // Ensure we always have a roles object
    const roles = user?.roles || { Employee: false }
    console.log('useAuth hook - user:', user)
    console.log('useAuth hook - roles:', roles)

    return {
        roles,
        username: user?.username,
        employeeId: user?.employeeId,
        isAdmin: roles?.Admin === true,
        isVoorman: roles?.Voorman === true,
        isManager: roles?.Manager === true,
        isEmployee: roles?.Employee === true,
        profile: user?.profile || {},
        crew: user?.crew || {},
        id: user?.id
    }
}

export default useAuth
